export default "__VITE_ASSET__zyNlatEH__"